<template>
  <div class="applied-list">
    <div>
      <el-form ref="refSearchForm" :model="queryParams" label-width="100px" inline>
        <el-form-item label="规格型号">
          <el-input v-model="queryParams.productModel" size="small"  placeholder="请输入规格型号"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryParams.status" size="small" clearable placeholder="请选择状态">
            <el-option
                v-for="subItem in enumStatus"
                :key="subItem.value"
                :label="subItem.name"
                :value="subItem.value"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" round icon="el-icon-search" style="margin-left: 10px" @click="getPageList()">搜索</el-button>
          <el-button round size="small" @click="onClickClear">重置</el-button>
          <el-button round size="small" @click="batchPrint">批量打印</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-loading="listLoading">
      <div v-if="tableData.length">
        <el-table
            @select-all="onChangeTableAll"
            @selection-change="onChangeTableSelection"
            :data="tableData"
            border>
          <el-table-column :selectable="stateFormat"  type="selection" align="center" width="45" value=""></el-table-column>
          <el-table-column
              type="index"
              align="center"
              width="40">
          </el-table-column>
          <el-table-column
              prop="productName"
              show-overflow-tooltip
              align="center"
              label="产品名称"
              width="120">
          </el-table-column>
          <el-table-column
              prop="productCount"
              show-overflow-tooltip
              align="center"
              label="申请数量">
          </el-table-column>
          <el-table-column
              prop="printCount"
              show-overflow-tooltip
              align="center"
              label="打印数量">
          </el-table-column>
          <el-table-column
              prop="productModel"
              show-overflow-tooltip
              align="center"
              label="规格型号">
          </el-table-column>
          <el-table-column
              prop="lotNumber"
              show-overflow-tooltip
              align="center"
              label="批号">
          </el-table-column>
          <el-table-column
              prop="orderNo"
              show-overflow-tooltip
              align="center"
              label="订单号">
          </el-table-column>
          <el-table-column
              prop="createDate"
              show-overflow-tooltip
              align="center"
              label="申请时间"
              width="180">
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button
                  :disabled="(scope.row.status==='REVIEW_PASS'||scope.row.status==='REVIEW')"
                  type="text" @click="onClickEdit(scope.row)">修改
              </el-button>
              <el-button
                  :disabled="(scope.row.status==='REVIEW_PASS'||scope.row.status==='REVIEW')"
                  type="text" @click="onClickDelete(scope.row)">删除
              </el-button>
              <el-button
                  :disabled="!(scope.row.status==='REVIEW_PASS')"
                  type="text" @click="onClickPrint(scope.row)">打印
              </el-button>
              <el-button
                  :disabled="!(scope.row.status==='REVIEW_PASS')"
                  type="text" @click="canlePrint(scope.row)">撤回
              </el-button>
              <el-button
                  :disabled="!(scope.row.isCheck)"
                  type="text" @click="uploadrReport(scope.row)">上传报告
              </el-button>

<!--              <el-button type="text" @click="onClickProduct(scope.row)">产品信息</el-button>-->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 20px;"
            @size-change="handleSizeChange"
            @current-change="onChangeCurrent($event,1)"
            :current-page="queryParams.current"
            :page-size="queryParams.pageSize"
            :page-sizes="pageSizes"
            background
            layout="total, prev, pager, next, sizes"
            :total="queryParams.total">
        </el-pagination>
      </div>
      <div v-else style="text-align:center;margin:20px 0">
        <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
      </div>
    </div>
    <el-dialog
        class="dialog-code-box"
        append-to-body
        destroy-on-close
        title="产品信息模板选择"
        @close="onClickTemplateCancel"
        :visible="dialogTemplateVisible"
        width="1000px">
      <div class="dialog-info-box" v-if="dialogTemplateVisible">
        <el-form ref="refSearchForm" :model="dialogTemplateParams" label-width="100px" inline>
          <el-form-item label="模板名称">
            <el-input v-model="dialogTemplateParams.name" size="small" clearable
                      placeholder="请输入模板名称"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="primary" size="small" round icon="el-icon-search" @click="getDialogTemplateList()">搜索
            </el-button>
            <el-button round size="small" @click="onClickDialogTemplateClear">重置</el-button>
          </el-form-item>
        </el-form>
        <div v-loading="dialogTemplateLoading">
          <div v-if="dialogTemplateData.length">
            <el-table
                row-key="uuid"
                :data="dialogTemplateData"
                @select-all="selectAll"
                @selection-change="handleSelectionChange"
                ref="refDialogTemplate"
                border>
              <el-table-column
                  type="selection"
                  align="center"
                  reserve-selection
                  width="45">
              </el-table-column>
              <el-table-column
                  type="index"
                  align="center"
                  width="40">
              </el-table-column>
              <el-table-column
                  prop="name"
                  show-overflow-tooltip
                  align="center"
                  label="模板名称">
              </el-table-column>
              <el-table-column
                  prop="model"
                  show-overflow-tooltip
                  align="center"
                  label="适用型号">
              </el-table-column>
              <el-table-column
                  prop="productModel"
                  show-overflow-tooltip
                  align="center"
                  label="状态"
                  width="120">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status===1" type="success">
                    已发布
                  </el-tag>
                  <el-tag v-else type="info">
                    未发布
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  show-overflow-tooltip
                  align="center"
                  label="创建时间">
              </el-table-column>
              <!--              <el-table-column label="操作" align="center" width="60">-->
              <!--                <template slot-scope="scope">-->
              <!--                  <el-button type="text" @click="onClickView(scope.row)">查看</el-button>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
            </el-table>
            <el-pagination
                style="margin-top: 20px;"
                @current-change="onChangeCurrent($event,2)"
                :current-page="dialogTemplateParams.current"
                :page-size="dialogTemplateParams.pageSize"
                background
                layout="total, prev, pager, next"
                :total="dialogTemplateParams.total">
            </el-pagination>
          </div>
          <div v-else style="text-align:center;margin:20px 0">
            <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onClickTemplateCancel">取 消</el-button>
        <el-button size="small" type="primary" :loading="dialogTemplateBoundLoading" @click="onClickTemplateSubmit">
          选 择
        </el-button>
      </span>
    </el-dialog>
    <product-info v-if="showInfo"/>

    <el-dialog
        title="水泵码打印信息"
        :destroy-on-close="true"
        :visible.sync="printDialogVisible"
        lock-scroll
        append-to-body
        width="435px"
    >
      <div id="nbprint">
        <!-- 打印的样式必须写在行内，写在class则无效 -->
        <div v-if="modelType=='1'" >
          <div
              v-for="(item, index) in  detailList"
              :key="index"
              style="width: 435px;height:327px; margin: 0px 0 6px 0;display: block;position: relative;box-sizing:border-box;"
              v-bind:style="{backgroundImage:'url(' + oneBgUrl + ')',backgroundRepeat:'no-repeat',backgroundSize:'100% 100%'}"
          >
            <img
                id="2wm"
                title="水泵码"
                :src="item.qrContent"
                alt="水泵码"
                style="width:125px;height:125px;position: absolute; right:60px;top:145px; transform: translateY(-50%);"
            />
            <!--新华泵业的条码去掉、显示产品码-->
            <div v-if="item.enterpriseUuid=='8a6a62c18991b83d0189d8f0f12701ce'" class="code" style="position: absolute;width: 100%;bottom:15px;margin: 0 auto;">
<!--              <div-->
<!--                  style="display: block;margin: 0 auto;font-size: 13px;text-align: center;margin-bottom:2px"-->
<!--              >型号:{{ productModel }}</div>-->
              <div style="height: 15px"></div>
              <div
                  style="width: 260px;display: block;margin: 0 auto;font-size: 13px;text-align: center;position: absolute;bottom: -2px;left: 50%;transform: translateX(-50%);"
              >{{ item.productCode }}</div>
            </div>

            <div v-else class="code" style="position: absolute;width: 100%;bottom:6px;margin: 0 auto;">
<!--              <div-->
<!--                  style="display: block;margin: 0 auto;font-size: 12px;text-align: center;font-size:8px;margin-bottom:2px"-->
<!--              >型号:{{ productModel }}</div>-->
              <barcode
                  style="text-align:center;height:100%"
                  :format="CODE39"
                  :displayValue="false"
                  :value="item.productCode"
                  :width="1.2"
                  :margin-left="2"
                  :margin-right="2"
                  :margin-top="1"
                  :margin-bottom="0"
                  :height="30"
                  :text-margin="3"
                  :font-size="12"
              >条码打印失败</barcode>
              <div
                  style="width: 260px;display: block;margin: 0 auto;font-size: 12px;text-align: center;font-size:8px;position: absolute;bottom: -2px;left: 50%;transform: translateX(-50%);"
              >{{ item.waterPumpCode }}</div>
            </div>
          </div>
        </div>
        <div v-else>
          <div
              v-for="(item, index) in detailList"
              :key="index"
              style="width: 435px;height:298px; margin: 0px 0 6px 0;display: block;position: relative;box-sizing:border-box;"
              v-bind:style="{backgroundImage:'url(' + twoBgUrl + ')',backgroundRepeat:'no-repeat',backgroundSize:'100% 100%'}"
          >
            <div style="width: 100%; height: 100%;margin: 0px auto;position: relative;">
              <img
                  style="width:140px;height:140px;position: absolute; right:66px;top:115px; transform: translateY(-50%);"
                  :src="item.qrContent"
              />
              <div
                  id="qrCodemodel"
                  style="position:absolute;width: 38%;bottom:33%;left:50%;color:#000;font-size:10px;color:#000;white-space:nowrap;text-align:center"
              >
                {{
                  item.productCode.length > 15 ? item.productCode.substring(item.productCode.length - 15, item.productCode.length) : item.productCode
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-print="printOption" type="primary" size="mini" :loading="printLoading">打印</el-button>
      </span>
    </el-dialog>

    <el-dialog
        :visible.sync="dialogVisible"
        title="提示"
        lock-scroll
        append-to-body
        width="435px"
        style="margin-top: 18vh;"
    >
      <span style="text-align:center;margin:20px;font-size: 16px;">请确认是否撤回该条数据</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="doCancle">
            确认
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog
        class="dialog-code-box"
        append-to-body
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :visible.sync="dialogReportVisible"
        width="40%">
      <span slot="title">
        <div class="dialog-title">
          <div class="dialog-text">上传报告
          </div>
        </div>
      </span>
      <div class="dialog-info-box">
        <el-form :model="dialogCodeForm" :rules="dialogCodeRule" ref="refDialogCodeForm" label-width="auto">
          <el-row :gutter="20" style="margin-left: 10px; margin-right: 10px;">
            <el-col :span="18" >
              <el-form-item label="检测报告">
                <el-upload
                    drag
                    action="/service-center/upload/file/single"
                    :headers="headers"
                    :file-list="dialogCodeForm.reportFiles"
                    :on-success="(response,file, fileList)=>handleQualityAptitudeSuccess(response,file, fileList)"
                    :on-remove="(file, fileList)=>handleQualityAptitudeRemove(file, fileList)"
                    :on-preview="handlePreviewDownload">
                  <i class="el-icon-upload"></i>
                  <div v-if="dialogCodeDisabled" class="el-upload__text">审批中的文件不可修改。</div>
                  <div v-else class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" round @click="dialogReportVisible = false">取 消</el-button>
        <el-button size="small" round type="primary"
                   :loading="dialogCodeLoading" @click="onClickReportSubmit">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {
  canleCodeTraceability,
  deleteCodeTraceability,
  getCodeTraceabilityList,
  getTemplateList, queryCodeTraceabilityTranslationList,
  sendTemplateBound, updataTranslationDetailPrint, uploadReport
} from "../../utils/interface";
import ProductInfo from "./reversoProductInfo";
import modelOne from "@/assets/model_one.png";
import modeltwo from "@/assets/model_two.jpg";

export default {
  components: {
    ProductInfo,
  },
  data() {
    return {
      headers: {
        'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
      },
      multipleSelection: [],
      multipleSelectionUuid: '',
      pageSizes: [10,20,50,100,500],
      showInfo: false,
      tableData: [],
      queryParams: {
        productModel: '',
        status: '',
        current: 1,
        pageSize: 10,
        total: 0,
        enterpriseUuid: this.$store.state.isUsermessage.uuid,
      },
      queryDetailParams: {
        mainUuids: '',
        current: 1,
        pageSize: 10,
        total: 0,
        enterpriseUuid: this.$store.state.isUsermessage.uuid,
      },
      enumStatus: [{
        value: 'INIT',
        name: '未审核',
      }, {
        value: 'REVIEW',
        name: '待审核',
      }, {
        value: 'NOT_PASS',
        name: '审核不通过',
      }, {
        value: 'REVIEW_PASS',
        name: '审核通过',
      }, {
        value: 'FINISH',
        name: '已生成',
      },],
      listLoading: false,
      dialogTemplateVisible: false,
      dialogTemplateLoading: false,
      dialogTemplateBoundLoading: false,
      dialogRowData: {},
      dialogTemplateData: [],
      dialogMultipleTable: [],
      dialogTemplateParams: {
        name: '',
        model: '',
        current: 1,
        pageSize: 10,
        total: 0,
      },
      modelType: "1",
      oneBgUrl: modelOne,
      twoBgUrl: modeltwo,
      detailList:[],
      printDialogVisible: false,
      printLoading: false,
      printOption: {
        id: "nbprint", // 打印元素的id 不需要携带#号
        preview: false, // 开启打印预览
        previewTitle: "", // 打印预览标题
        popTitle: "水泵码", // 页眉标题 默认浏览器标题 空字符串时显示undefined 使用html语言
        // 头部文字 默认空 在节点中添加 DOM 节点， 并用,(Print local range only)分隔多个节点
        extraHead: "",
        // 新的 CSS 样式表， 并使用,（仅打印本地范围）分隔多个节点
        extraCss: "",
        previewBeforeOpenCallback: () => {
          // console.log("触发打印预览打开前回调");
        },
        previewOpenCallback: () => {
          // console.log("触发打开打印预览回调");
        },
        beforeOpenCallback: () => {
          // console.log("触发打印工具打开前回调");
        },
        openCallback: () => {
          // console.log("触发打开打印工具回调");
        },
        closeCallback: () => {
          // console.log("触发关闭打印工具回调");
          this.printAfter();
        },
        clickMounted: () => {
          console.log("触发点击打印回调");
        }
      },
      dialogVisible:false,
      cancleData:'',
      dialogReportVisible:false,
      dialogCodeLoading:false,
      dialogCodeDisabled:false,
      dialogCodeForm: {
        reportFiles: [],
      },
      dialogCodeRule: {
        reportFiles: [
          {required: true, message: '请上传报告', trigger: 'blur'},
          {required: true, message: '请上传报告', trigger: 'change'},
        ],
      },
      mainId:'',
    };
  },
  created() {

  },
  methods: {
    initData() {
      this.getPageList()
      this.getOptionsData()
    },
    getPageList() {
      this.listLoading = true
      getCodeTraceabilityList(this.queryParams).then((res) => {
        this.listLoading = false
        if (res.list) {
          this.tableData = res.list
          this.queryParams.total = res.total
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    getOptionsData() {

    },
    onClickEdit(row) {
      this.$emit('onChangeType', 0, row)
    },
    onClickDelete(row) {
      deleteCodeTraceability(row.uuid).then((res) => {
        this.listLoading = false
        if (res.success) {
          this.getPageList()
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    onClickPrint(row) {
      if (row.isCheck && !row.isUploadReportFile){
        this.$message({
          type: "warning",
          message:"检测报告未上传",
        })
      }
      this.$emit('onChangeStep', 4, row)
    },
    uploadrReport(row){
      this.dialogReportVisible = true;
      this.mainId = row.uuid
    },

    handleQualityAptitudeSuccess(response, file, fileList) {
      this.dialogCodeForm['reportFiles'] = []
      for (const item of fileList) {
        //新上传的文件
        if (item.response !== undefined) {
          this.dialogCodeForm['reportFiles'].push({
            url: item.response.url,
            name: item.name,
            mainId: this.mainId,
          })
        } else {//已经上传的文件
          this.dialogCodeForm['reportFiles'].push({
            url: item.url,
            name: item.name,
            mainId: this.mainId,
          })
        }
      }
    },
    handleQualityAptitudeRemove(file, fileList) {
      this.dialogCodeForm['reportFiles'] = []
      for (const item of fileList) {
        //新上传的文件
        if (item.response !== undefined) {
          this.dialogCodeForm['reportFiles'].push({
            url: item.response.url,
            name: item.name,
          })
        } else {//已经上传的文件
          this.dialogCodeForm['reportFiles'].push({
            url: item.url,
            name: item.name,
          })
        }
      }
    },
    handlePreviewDownload(file) {
      let a = document.createElement('a')
      a.href = file.url
      a.download = file.name //同源策略限制无法生效
      a.click()
    },
    onClickReportSubmit(){
      this.dialogCodeLoading=true;
      uploadReport(this.mainId,this.dialogCodeForm['reportFiles']).then((res) => {
        this.dialogCodeLoading = false
        this.dialogReportVisible = false;
        this.$message({
          type: res.success ? "success" : "warning",
          message: res.success ? "上传成功" : "上传失败",
        })
        this.getPageList()
      }).catch(err => {
        this.dialogTemplateBoundLoading = false
      })


    },
    onClickProduct(row) {
      this.dialogRowData = row
      this.dialogTemplateVisible = true
      this.$nextTick(() => {
        this.getDialogTemplateList()
      })
    },
    getDialogTemplateList() {
      this.dialogTemplateLoading = true
      getTemplateList(this.dialogTemplateParams).then((res) => {
        this.dialogTemplateLoading = false
        if (res.list) {
          this.dialogTemplateData = res.list
          this.dialogTemplateParams.total = res.total
          if (this.dialogRowData && this.dialogRowData.explanationId && this.dialogTemplateData.length) {
            this.$nextTick(() => {
              //勾选回显
              let selectRow = this.dialogTemplateData.find(item => item.uuid === this.dialogRowData.explanationId)
              if (selectRow) {
                this.$refs.refDialogTemplate.clearSelection()
                this.$refs.refDialogTemplate.toggleRowSelection(selectRow, true)
              }
            })
          }
        }
      }).catch(err => {
        this.dialogTemplateLoading = false
      })
    },
    onClickDialogTemplateClear() {
      this.dialogTemplateParams = {
        name: '',
        model: '',
        current: 1,
        pageSize: 10,
        total: 0,
      }
      this.getDialogTemplateList()
    },
    onClickTemplateSubmit() {
      console.log(this.dialogRowData)
      console.log(this.dialogMultipleTable.name)
      this.dialogTemplateBoundLoading = true
      let data = {
        uuid: this.dialogRowData.uuid,
        explanationId: this.dialogMultipleTable.uuid,
      }
      sendTemplateBound(data).then((res) => {
        this.dialogTemplateBoundLoading = false
        this.$message({
          type: res.success ? "success" : "warning",
          message: res.success ? "绑定成功" : "绑定失败",
        })
        if (res.success) {
          this.onClickTemplateCancel()
        }
        this.getPageList()
      }).catch(err => {
        this.dialogTemplateBoundLoading = false
      })
    },
    onClickTemplateCancel() {
      this.dialogTemplateVisible = false
      this.dialogRowData = {}
      this.dialogTemplateData = []
      this.dialogMultipleTable = []
      this.dialogTemplateParams = {
        name: '',
        model: '',
        current: 1,
        pageSize: 10,
        total: 0,
      }
    },
    handleSelectionChange(selection) {
      this.$nextTick(() => {
        if (selection.length > 1) {
          this.$refs.refDialogTemplate.clearSelection()
          this.$refs.refDialogTemplate.toggleRowSelection(selection.pop())
        }
        if (selection[0]) {
          this.dialogMultipleTable = JSON.parse(JSON.stringify(selection[0]))
        }
      })
    },
    selectAll() {
      this.$refs.refDialogTemplate.clearSelection()
    },
    onClickClear() {
      this.$refs['refSearchForm'].resetFields()
      this.queryParams = {
        productModel: '',
        status: '',
        current: 1,
        pageSize: 10,
        total: 0,
      }
      this.getPageList()
    },
    onChangeCurrent(e, type) {
      if (type === 1) {
        this.queryParams.current = e
        this.getPageList()
      } else if (type === 2) {
        this.dialogTemplateParams.current = e
        this.getDialogTemplateList()
      }
    },
    handleSizeChange(pageSize) {
      this.queryParams.pageSize = pageSize
      // 在此刷新数据
      this.getPageList()
    },
    eachDictName(status) {
      return this.enumStatus.find(item => item.value === status).name
    },
    onChangeTableSelection(selection) {
      this.multipleSelectionUuid = '';
      this.multipleSelection = selection;
    },
    onChangeTableAll() {
      // this.$refs.refTable.clearSelection()
    },
    stateFormat(row, column) {
      if (row.status==='REVIEW_PASS') {
        return true
      } else  {
        return false
      }
    },
    batchPrint(){
      console.log( this.multipleSelection)
      if (this.multipleSelection.length > 0) {
        this.printDialogVisible = true;
        this.modelType = this.multipleSelection[0].modelType;
        for(var i = 0; i< this.multipleSelection.length; i++){
          console.log('id:'+this.multipleSelection[i].uuid)
          this.multipleSelectionUuid=this.multipleSelection[i].uuid+","+this.multipleSelectionUuid;
        }
        // 查询明细数据
        this.queryDetailParams.mainUuids =  this.multipleSelectionUuid;
        queryCodeTraceabilityTranslationList(this.queryDetailParams).then((res) => {
          this.listLoading = false
          if (res.list) {
            this.detailList = res.list
            this.printDialogVisible =true;
          }
        }).catch(err => {
          this.listLoading = false
        })
      } else {
        this.$message.warning("请选择要打印的列表!");
      }
    },
    printAfter(){
      let uuidList = [];
      for(var i = 0; i< this.detailList.length; i++){
        // console.log('id:'+this.detailList[i].uuid)
        uuidList.push(this.detailList[i].uuid)
      }
      if (uuidList.length>0){
        updataTranslationDetailPrint(uuidList).then((res) => {
          console.log(res)
        }).catch(err => {

        })
      }
    },
    canlePrint(row){
      this.dialogVisible =true;
      this.cancleData = row;
    },
    doCancle(){
      console.log(this.cancleData)
      canleCodeTraceability(this.cancleData.uuid).then((res) => {
        this.listLoading = false
        this.dialogVisible =false;
        if (res.success) {
          this.getPageList()
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .el-dialog__body {
  overflow-y: auto !important;
  //height: 60vh !important;
  padding: 0px !important;
}

.applied-list {
  /deep/ .el-button--small.is-round {
    padding: 9px 26px;
  }
}

@media print {
  #nbprint {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    #2wm {
      right: 0;
    }
    #qrCode1Bg1 {
      //display: none;
      //visibility: hidden;
    }
    #qrCode2Bg2 {
      //display: none;
      //visibility: hidden;
    }
  }
}
</style>

<style media="print" scoped lang="less">
/*去除打印的页眉页脚*/
@page :left {
  margin-left: 0cm;
  padding-left: 0cm;
}

@page :right {
  margin-left: 0cm;
  padding-left: 0cm;
}
</style>



// WEBPACK FOOTER //
// src/components/codeTraceabilityOther/reversoAppliedList.vue